import { css, cx } from '@emotion/css';
import { Typography } from 'antd';

import { typographyStyle } from '../../style';

type TextProps = React.ComponentProps<typeof Typography.Text> & {
  textStyle?: keyof typeof typographyStyle;
};

export const Text = ({ children, textStyle, className, ...props }: TextProps) => {
  return (
    <Typography.Text
      className={cx(textStyle && css(typographyStyle[textStyle]), className)}
      {...props}
    >
      {children}
    </Typography.Text>
  );
};
